import {Component, store, constant} from '../../index';
import {
  numberFormat,
  getTranslation,
  addCurrencySymbol,
  calculateAllSpecialAddonTotalPrice,
  addAllSpecialDiscountedAddons,
  calculateSpecialAddonOldPrice,
} from '../index';

export default class SpecialAddons extends Component {
  constructor() {
    super({
      store,
      element: document.querySelector('.pure-circle-all-box'),
      state: store.state,
    });
  }

  render() {
    const planObject = this.state.selected_plan;
    let addonsHtml = '';
    const specialAddonsMainWrapper = document.querySelector('.pro-pure-circle-wrapper');
    const oldAddonPriceWrapper = document.querySelector('.pro-pure-circle-wrapper .pcircle-cut-price p');
    const newAddonPriceWrapper = document.querySelector('.pro-pure-circle-wrapper .pcircle-price-add-all .new-price');

    const addonsToBeDisplay = constant.specialAddonList;
    const selectedPlan = this.state.selected_plan ? this.state.selected_plan : {};
    const addonList = selectedPlan.addons ? selectedPlan.addons : [];
    const currencyCode = this.state.currency_code ? this.state.currency_code : 'USD';
    const selectedAddons = this.state.selected_addons ? this.state.selected_addons : [];
    let [specialAddonsTotal, discountedSpecialAddonsTotal] = calculateAllSpecialAddonTotalPrice();
    if (oldAddonPriceWrapper && newAddonPriceWrapper) {
      specialAddonsTotal = numberFormat(Number(specialAddonsTotal) / Number(selectedPlan.interval_length));
      oldAddonPriceWrapper.innerHTML = addCurrencySymbol(specialAddonsTotal);

      discountedSpecialAddonsTotal = numberFormat(Number(discountedSpecialAddonsTotal) / Number(selectedPlan.interval_length));
      newAddonPriceWrapper.innerHTML = addCurrencySymbol(discountedSpecialAddonsTotal);
    }

    if (addonList.length) {
      for (const addon of addonList) {
        let addonTitle = getTranslation(addon.code);
        let addonPrice = numberFormat(Number(addon.unit_amount) / Number(selectedPlan.interval_length));
        const specialAddonsOldPrice = calculateSpecialAddonOldPrice(addon.code);

        if (addon.state === 'active' && addonsToBeDisplay.includes(addon.code)) {
          addonsHtml += `
            <div class="special-addon-box ${
              selectedAddons.includes(addon.code) || selectedAddons.includes(`${addon.code}_discounted`) ? 'active' : ''
            }" addon-code="${addon.code}">
              <div class="pure-keep-hdg">
                ${getTranslation(`${addon.code}_special_addons_icon`)}
                  <h3>${addonTitle}</h3>
                  <span class="addon-hdg-info">${getTranslation(`${addon.code}_heading_info`)}</span>
                  <div class="pkeep-checkbox">
                  <input type="checkbox" id="${addon.code}" class="pcircle-checkbox" name="${addon.code}" value="${addon.code}"
                  ${selectedAddons.includes(addon.code) || selectedAddons.includes(`${addon.code}_discounted`) ? 'checked' : ''}>
              </div>
              </div>
              <span class="addon-subhdg">${getTranslation(`${addon.code}_special_addons_sub_heading`)}</span>
              <div class="pkeep-pera">
                ${getTranslation(`${addon.code}_special_addons_para`)}
              </div>
              <div class="pkeep-price-checkbox-box">
                ${specialAddonsOldPrice ? `<p class="sp-addons-cut-price">${addCurrencySymbol(specialAddonsOldPrice)}</p>` : ''}
                <p>
                  ${addCurrencySymbol(addonPrice)}
                  <span>/${getTranslation('mo')}</span>
                </p>
                
              </div>
            </div>
          `;
        }
      }
      
    }

    if(specialAddonsMainWrapper) {
      if (addonsHtml == '') {
        specialAddonsMainWrapper.style.display = 'none';
      } else {
        specialAddonsMainWrapper.style.display = 'block';
      }
    }

    /* Removing special addon boxes before appending new addon boxes */
    const addonBoxes = this.element?.querySelectorAll('.special-addon-box ') || [];
    addonBoxes.forEach(box => {
      box.remove();
    });

    if(this.element) {
      this.element.innerHTML = this.element.innerHTML + addonsHtml;
    }
  }
}
